import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const pricingSection = document.getElementById('pricing');
      let hideAtBottom = false;
      if (pricingSection) {
        const rect = pricingSection.getBoundingClientRect();
        if (rect.top < window.innerHeight) {
          hideAtBottom = true;
        }
      }
      setIsVisible(scrollY > 600 && !hideAtBottom);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-189">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-6 left-0 right-0 z-50 flex justify-center px-4 pointer-events-none" data-id="element-190">
          <div className="pointer-events-auto" data-id="element-191">
            <motion.a href="#pricing" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center justify-center gap-2 bg-[#c06a52] hover:bg-[#b35f48] text-white font-bold text-base px-8 py-4 rounded-full shadow-2xl shadow-[#c06a52]/40 border-2 border-white/20 transition-colors" data-id="element-192">
              🚀 QUIERO EL MEGA PACK
            </motion.a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}